function Gambia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1221)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.38529 0 3.70854 4.01413 1.27173 9.73913H30.7283C28.2915 4.01413 22.6147 0 16 0Z" fill="#A2001D"/>
  <path d="M16 31.9999C22.6147 31.9999 28.2915 27.9857 30.7282 22.2607H1.27173C3.70854 27.9857 9.38529 31.9999 16 31.9999Z" fill="#496E2D"/>
  <path d="M31.4488 11.8262H0.551188C0.1925 13.157 0 14.5559 0 16.0001C0 17.4443 0.1925 18.8432 0.551188 20.174H31.4489C31.8075 18.8432 32 17.4443 32 16.0001C32 14.5559 31.8075 13.157 31.4488 11.8262V11.8262Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Gambia;
